import { Empty } from 'antd';
import { useRouter } from 'next/router';
import { ArticleHeader } from '@/components/article/ArticleMobile';
import { useUserAgentInfo } from '@/context/user-agent';
import { ProductInfo } from '@/services/document';
import Head from 'next/head';

/**
 * 暂无文档的空状态，还没有设计稿，此为临时页面
 */

type Props = {
  productList: ProductInfo[];
};
export default function ArticleNoContent(props: Props) {
  const { productList } = props;
  const router = useRouter();
  const productCode: string = router.query.productCode as string;
  const productName: string = productList.find(
    (info) => info.productCode === productCode
  ).productName;
  const { isMobile } = useUserAgentInfo();

  return (
    <>
      <Head>
        <title>文档-{productName}-StreamLake</title>
      </Head>
      <div
        style={{
          height: 'calc(100vh - 317px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {isMobile && (
          <ArticleHeader
            key={productCode}
            showCategoryTrigger={false}
            productCode={productCode}
            productName={productName}
            topDocs={productList}
            onTriggerCategory={() => undefined}
          />
        )}
        <Empty description="文档建设中" />
      </div>
    </>
  );
}
